import { jsxs as e, jsx as C } from "react/jsx-runtime";
import { DEFAULT_METRIC_ICON_SIZE as i } from "./index.es2447.js";
function t({ size: l = i }) {
  return /* @__PURE__ */ e(
    "svg",
    {
      width: l,
      height: l,
      viewBox: "0 0 56 56",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg",
      children: [
        /* @__PURE__ */ C("rect", { width: "56", height: "56", rx: "3", fill: "#F3F3FD" }),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M27.9993 27.868C29.8405 27.868 31.3333 26.3752 31.3333 24.534C31.3333 22.6941 29.8405 21.2 27.9993 21.2C26.1594 21.2 24.6666 22.6941 24.6666 24.534C24.6666 26.3752 26.1594 27.868 27.9993 27.868Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            d: "M17.3334 36C17.3334 34.2572 20.3058 32.7747 24.4532 32.2265C26.1504 33.82 27.9994 35.4415 27.9994 35.4415C27.9994 35.4415 29.8484 33.8199 31.5457 32.2263C35.6938 32.7744 38.6667 34.257 38.6667 36C38.6667 38.2092 33.8911 40 28 40C22.109 40 17.3334 38.2092 17.3334 36Z",
            fill: "white"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M36 24.4841C36 20.0756 32.4256 16.5 28.0159 16.5H27.9841C23.5744 16.5 20 20.0756 20 24.4841C20 26.5431 20.6965 28.2214 22.0654 29.8297C23.433 31.4367 27.9994 35.4415 27.9994 35.4415C27.9994 35.4415 32.5657 31.4367 33.9333 29.8297C35.3035 28.2214 36 26.5431 36 24.4841ZM27.9993 27.868C29.8405 27.868 31.3333 26.3752 31.3333 24.534C31.3333 22.6941 29.8405 21.2 27.9993 21.2C26.1594 21.2 24.6666 22.6941 24.6666 24.534C24.6666 26.3752 26.1594 27.868 27.9993 27.868Z",
            fill: "#E1E2FF"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M27.9993 20.7C25.883 20.7 24.1666 22.4183 24.1666 24.534C24.1666 26.6512 25.8831 28.368 27.9993 28.368C30.1166 28.368 31.8333 26.6514 31.8333 24.534C31.8333 22.4181 30.1168 20.7 27.9993 20.7ZM25.1666 24.534C25.1666 22.97 26.4358 21.7 27.9993 21.7C29.5642 21.7 30.8333 22.9701 30.8333 24.534C30.8333 26.0991 29.5644 27.368 27.9993 27.368C26.4357 27.368 25.1666 26.0992 25.1666 24.534Z",
            fill: "#5E63E5"
          }
        ),
        /* @__PURE__ */ C(
          "path",
          {
            fillRule: "evenodd",
            clipRule: "evenodd",
            d: "M21.6846 30.1538C22.1479 30.6981 22.954 31.4964 23.822 32.3185C20.0075 32.9281 17.3334 34.3469 17.3334 36C17.3334 38.2092 22.109 40 28 40C33.8911 40 38.6667 38.2092 38.6667 36C38.6667 34.3468 35.9921 32.9278 32.1769 32.3183C33.0449 31.4963 33.8509 30.6981 34.3141 30.1538C35.7508 28.4673 36.5 26.677 36.5 24.4841C36.5 19.7996 32.7018 16 28.0159 16H27.9841C23.2982 16 19.5 19.7996 19.5 24.4841C19.5 26.6771 20.2493 28.4674 21.6846 30.1538ZM27.9841 17C23.8506 17 20.5 20.3517 20.5 24.4841C20.5 26.4092 21.1438 27.9755 22.4462 29.5056C23.1059 30.2809 24.5646 31.6621 25.8829 32.8695C26.5371 33.4686 27.1488 34.0178 27.5972 34.4174C27.7526 34.5559 27.8884 34.6764 27.9994 34.7747C28.1104 34.6764 28.2461 34.5559 28.4016 34.4174C28.8499 34.0178 29.4616 33.4686 30.1158 32.8695C31.4342 31.6621 32.8928 30.2809 33.5525 29.5057C34.8561 27.9756 35.5 26.4091 35.5 24.4841C35.5 20.3517 32.1494 17 28.0159 17H27.9841ZM27.6696 35.8174L27.6174 35.7715L27.4695 35.641C27.3415 35.528 27.1572 35.3648 26.9318 35.1639C26.4812 34.7624 25.8659 34.21 25.2075 33.607C25.0604 33.4722 24.9108 33.3346 24.76 33.1953C23.2346 33.3852 21.886 33.7039 20.8087 34.1079C19.9092 34.4453 19.2507 34.8228 18.835 35.1913C18.4182 35.5608 18.3334 35.8364 18.3334 36C18.3334 36.1636 18.4182 36.4392 18.835 36.8087C19.2507 37.1773 19.9092 37.5548 20.8087 37.8921C22.6004 38.564 25.1427 39 28 39C30.8574 39 33.3997 38.564 35.1914 37.8921C36.0909 37.5548 36.7494 37.1773 37.1651 36.8087C37.5819 36.4392 37.6667 36.1636 37.6667 36C37.6667 35.8364 37.5819 35.5608 37.1651 35.1913C36.7494 34.8228 36.0909 34.4453 35.1914 34.1079C34.1138 33.7038 32.7647 33.3851 31.2389 33.1952C31.0881 33.3345 30.9383 33.4722 30.7912 33.607C30.1328 34.21 29.5175 34.7624 29.0669 35.1639C28.8415 35.3648 28.6573 35.528 28.5292 35.641L28.3813 35.7715L28.3291 35.8174L27.9994 36.1066L27.6696 35.8174Z",
            fill: "#5E63E5"
          }
        )
      ]
    }
  );
}
t.__tags = [];
export {
  t as MetricLocationIcon
};
//# sourceMappingURL=index.es416.js.map
